import React from 'react';
import { Button } from '@helpcenter/analytics-components';
import { useIntl } from 'react-intl';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import Modal, {
	ModalBody,
	ModalFooter,
	ModalHeader,
	ModalTitle,
	ModalTransition,
} from '@atlaskit/modal-dialog';
import { ContextualAnalyticsData, MODAL } from '@atlassian/analytics-bridge';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import messages from './messages';

export interface Props {
	isOpen: boolean;
	onClose: () => void;
}

export const UnlinkAllProjectsWarningModal = ({ isOpen, onClose }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<ContextualAnalyticsData sourceType={MODAL} sourceName="helpCenterUnlinkAllWarning">
			<ModalTransition>
				{isOpen && (
					<Modal width="small" onClose={onClose}>
						<ModalHeader>
							<ModalTitle testId="help-center-unlink-all-projects-warning-modal-title">
								{FeatureGates.checkGate('itsm-project-renaming')
									? formatMessage(messages.unlinkAllWarningModalTitleGalaxia)
									: formatMessage(messages.unlinkAllWarningModalTitle)}
							</ModalTitle>
						</ModalHeader>
						<ModalBody>
							{FeatureGates.checkGate('itsm-project-renaming')
								? formatMessage(messages.unlinkAllWarningModalDescriptionGalaxia)
								: formatMessage(messages.unlinkAllWarningModalDescription)}
						</ModalBody>
						<ModalFooter>
							<Button
								onClick={onClose}
								appearance="primary"
								actionSubjectId="unlinkAllWarningModalOkButton"
							>
								{formatMessage(messages.unlinkAllWarningModalOkButton)}
							</Button>
						</ModalFooter>
					</Modal>
				)}
			</ModalTransition>
			<FireScreenEventOnMount />
		</ContextualAnalyticsData>
	);
};
